export default __webpack_public_path__ + "dbc2a96ae2ce37ccb7bcf60f1ad1b231.png";